import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54e1afe5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: "product-card ion-text-center",
    color: $props.isFeatured ? 'primary' : '',
    "router-link": {
    name: 'ProductDetailPage',
    params: { id: $props.product.id },
    state: { ...$props.extraRouterParams },
  },
    button: ""
  }, {
    default: _withCtx(() => [
      ($props.product.sellingPrice < $props.product.price)
        ? (_openBlock(), _createBlock(_component_ion_badge, {
            key: 0,
            class: "sale-badge",
            color: "danger"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('sale')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($props.isFeatured)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "featured-product-img",
            src: $props.product.imageLink
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("img", {
            key: 2,
            class: "product-img",
            src: $props.product.imageLink
          }, null, 8, _hoisted_2)),
      _createVNode(_component_ion_card_header, { class: "product-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_subtitle, { class: "ion-text-nowrap" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.locale == 'zh' ? $props.product.title : ($props.product.titleEn || $props.product.title)), 1)
            ]),
            _: 1
          }),
          ($props.product.sellingPrice != $props.product.price)
            ? (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                key: 0,
                class: "product-price"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("s", null, "HK$" + _toDisplayString(Number($props.product.price).toLocaleString()), 1),
                  _createTextVNode(" HK$" + _toDisplayString(Number($props.product.sellingPrice).toLocaleString()), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_card_subtitle, {
                key: 1,
                class: "product-price"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" HK$" + _toDisplayString(Number($props.product.sellingPrice).toLocaleString()), 1)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      (!$props.hideDetails && ($props.product.relatedProductVariants || $props.product.inStock))
        ? (_openBlock(), _createBlock(_component_ion_buttons, {
            key: 3,
            class: "product-actions"
          }, {
            default: _withCtx(() => [
              (!$props.product.relatedProductVariants && $props.product.inStock)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.addProductToCart($props.product)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.cartOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($props.userLoggedIn && $props.product.likedByUser)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($props.product, 'remove')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.heart,
                        color: "danger"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($props.userLoggedIn && !$props.product.likedByUser)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($props.product, 'add')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.heartOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!$props.product.relatedProductVariants && !$props.product.inStock)
        ? (_openBlock(), _createBlock(_component_ion_chip, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('soldOut')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["color", "router-link"]))
}